import NetworkLogic from "../../Shared/NetworkLogic"
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import ToggleItem from "../../Common/ToggleItem";
import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
import Utils from "../../Shared/Utils";
import Player from "../../Models/Player";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator

@ccclass
export default class BetRecordLayer extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Layout)
    lytContentRecords: cc.Layout = null

    @property(cc.Layout)
    lytContentGames: cc.Layout = null

    @property(cc.Node)
    nodeTemplateGame: cc.Node = null

    @property(cc.Node)
    nodeTemplateRecord: cc.Node = null

    @property(cc.Node)
    nodeScrollView: cc.Node = null

    @property(cc.Node)
    nodeTimes: cc.Node = null

    @property(cc.Node)
    nodeGames: cc.Node = null

    @property(cc.Label)
    lbTime: cc.Label = null

    @property(cc.Label)
    lbGame: cc.Label = null

    private _startTime = ""
    private _endTime = ""
    private _gameType = ""
    private _platform = ""

    onLoad() {
        this.nodeTemplateGame.parent = null
        this.nodeTemplateRecord.parent = null
        this.hideNodeList()
        this.toggleContainer.node.removeAllChildren()
        this.toggleContainer.node.destroyAllChildren()
        this.node.parent.parent.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    start() {
        let date = new Date()
        this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
        this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        this.createGameTypes()
    }

    onDisable() {
        this.hideNodeList()
    }

    onDestroy() {
        this.nodeTemplateGame.destroy()
        this.nodeTemplateRecord.destroy()
        this.node.parent.parent.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    onBtnClick(event, userData) {
        if (userData === "today") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "yesterday") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "month") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "gameType") {
            this.selectGame(event.target["gameCfg"])
        } else if (userData === "nodeTimes") {
            this.nodeTimes.active = !this.nodeTimes.active
        } else if (userData === "nodeGames") {
            this.nodeGames.active = !this.nodeGames.active
        } else if (userData === "copy") {
            Utils.copyText(event.target.parent["recordConfig"]["billNo"])
            UIManager.showToastUI(i18n.t('HallUI.copy_succ'), Global.ToastType.OK)
        }
    }

    onToggleSeclected(toggle: ToggleItem) {
        this.hideNodeList()
        this._gameType = toggle.userData["gameType"]
        this.createGameList(toggle.userData["children"])
    }

    hideNodeList() {
        this.nodeTimes.active = false
        this.nodeGames.active = false
    }

    private selectTimeNode(node: cc.Node, userData) {
        this.nodeTimes.active = false
        this.lbTime.string = node.getChildByName("name").getComponent(cc.Label).string

        if (userData === "today") {
            let date = new Date()
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        } else if (userData === "yesterday") {
            let date = new Date()
            date.setDate(date.getDate() - 1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        } else if (userData === "month") {
            let date = new Date()
            date.setDate(1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = (new Date())["format"]("yyyy-MM-dd ") + "23:59:59"
        }

        this.queryRecords()
    }

    private selectGame(gameCfg) {
        this.nodeGames.active = false
        this.lbGame.string = gameCfg ? gameCfg["gameTitleCn"] : i18n.t('PlayerCenter.all')
        this._platform = gameCfg ? gameCfg["platform"] : "all"
        this.queryRecords()
    }

    private createGameTypes() {
        UIManager.showLoadingUI()
        NetworkLogic.gameTypeList(function (data) {
            UIManager.hideLoadingUI()
            data.forEach(item => {
                this.toggleContainer.addDefaultToggle(item.gameTitleCn.substr(0, 2), item, 160)
            });
        }.bind(this))
    }

    private createGameList(gameList: []) {
        this.lytContentGames.node.removeAllChildren()
        this.lytContentGames.node.destroyAllChildren()
        let node = cc.instantiate(this.nodeTemplateGame)
        node.getChildByName("name").getComponent(cc.Label).string = i18n.t('PlayerCenter.all')
        node.parent = this.lytContentGames.node
        this.selectGame(undefined)

        gameList.forEach(gameCfg => {
            let node = cc.instantiate(this.nodeTemplateGame)
            node.getChildByName("name").getComponent("LocalizedLabel").dataID = gameCfg["gameTitleCn"]
            node["gameCfg"] = gameCfg
            node.parent = this.lytContentGames.node
        });
    }

    private queryRecords() {
        this.lytContentRecords.node.removeAllChildren()
        this.lytContentRecords.node.destroyAllChildren()

        UIManager.showLoadingUI()
        NetworkLogic.findUserRecord(this._startTime, this._endTime, this._gameType, this._platform, function (data) {
            UIManager.hideLoadingUI()
            data.data && data.data.forEach(item => {
                let node = cc.instantiate(this.nodeTemplateRecord)
                node.parent = this.lytContentRecords.node
                node["recordConfig"] = item
                node.getChildByName("time").getComponent(cc.Label).string = item.beijingTime
                node.getChildByName("num").getComponent(cc.Label).string = item.gameName + item.billNo
                node.getChildByName("money").getComponent(cc.Label).string =  item.currencySymbol + item.betNumber

                if (item.netNumber >= 0){
                    node.getChildByName("given").getComponent(cc.Label).string = "+" + item.currencySymbol + Math.abs(item.netNumber)
                }else {
                    node.getChildByName("given").getComponent(cc.Label).string = "-" + item.currencySymbol + Math.abs(item.netNumber)
                }
                this.lytContentRecords.node.children.length % 2 === 1 && (node.getChildByName("bg").opacity = 100)

                if (parseFloat(item.netNumber) > 0) {
                    node.getChildByName("given").color = cc.color(74, 190, 139)
                } else {
                    node.getChildByName("given").color = cc.color(190, 74, 74)
                }
            });
        }.bind(this))
    }
}